import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import HmEventRegistry from '../../../model/HmEventRegistry';

// ES6 className-style
class FlipSection extends PreLoginSessionCheck {
  componentDidMount(){
	  HmEventRegistry.fireEvent("INITIATE_GA");
  }
  render() {
  	return(
  		<section className="product-main our-lrn  mtb">
		 	<div className="container">  
		 		<div className="row flip-row"> 
		 			<div data-hover-ga="Our Learnings - Mathethatics is not a spectator sport - flip" className="col-md-4 col-sm-6 flip-main">  
		 				<div className="card-container">
							<div className="card">
								<div className="side">
									<img  src="../img/flp1.jpg" alt="flip img missing" />
									<div className="bottom-text">
										<p>Mathematics is not a spectator sport</p>
									</div>
								</div>
								<div className="side back">
									<div className="inner-text">	
									<h5>Mathematics is not a spectator sport</h5>
									<hr className="w-hr"/>
									<p>Just as in sport, even in Math - with more practice - you get better - and then start enjoying it</p>
									</div>
								</div>
							</div>
						</div>
		 			</div>
		 			<div data-hover-ga="Our Learnings - Literacy and Numeracy go together - flip" className="col-md-8 col-sm-6 flip-main">  
		 				<div className="card-container verticle-card">
							<div className="card">
								<div className="side">
									<div className="side-img">
										<img src="../img/flp2.jpg" className="flp2" alt="flip img missing"/>
										<img src="../img/flp2-new.jpg" className="flp2-new" alt="flip img missing"/>
									</div>
									<div className="bottom-text">
										<p>Literacy and Numeracy go together</p>
									</div>
								</div>
								<div className="side back">
									<div className="inner-text">	
									<h5>Literacy and Numeracy go together</h5>
									<hr className="w-hr"/>
									<p>Building a good vocabulary and comprehension skills are important stepping stones for Math</p>
									</div>
								</div>
							</div>
						</div>
		 			</div> 
		 			
		 			<div data-hover-ga="Our Learnings - Algebra requires a strong Arithmetic foundation - flip" className="col-md-4 col-sm-6 flip-main">  
		 				<div className="card-container">
							<div className="card">
								<div className="side">
									<img src="../img/flp3.jpg" alt="flip img missing"/>
									<div className="bottom-text">
										<p>Algebra requires a strong Arithmetic foundation</p>
									</div>
								</div>
								<div className="side back">
									<div className="inner-text">	
									<h5>Algebra requires a strong Arithmetic foundation</h5>
									<hr className="w-hr"/>
									<p>Mastering Fractions, Decimals, LCM, HCF, BODMAS really help when you begin Algebra</p>
									</div>
								</div>
							</div>
						</div>
		 			</div> 
		 			<div data-hover-ga="Our Learnings - Math is a powerful tool in interdisciplinary contexts - flip" className="col-md-4 col-sm-6 flip-main">  
		 				<div className="card-container">
							<div className="card">
								<div className="side">
									<img src="../img/flp4.jpg" alt="flip img missing"/>
									<div className="bottom-text">
										<p>Math is a powerful tool in interdisciplinary contexts</p>
									</div>
								</div>
								<div className="side back">
									<div className="inner-text">	
									<h5>Math is a powerful tool in interdisciplinary contexts</h5>
									<hr className="w-hr"/>
									<p>Math in virtually everywhere around us. From the Sciences to Humanities, Math can help solve real problems</p>
									</div>
								</div>
							</div>
						</div>
		 			</div>
		 			<div data-hover-ga="Our Learnings - Mathematical Thinking is all about processes - flip" className="col-md-4 col-sm-6 flip-main">  
		 				<div className="card-container">
							<div className="card">
								<div className="side">
									<img src="../img/flp5.jpg" alt="flip img missing"/>
									<div className="bottom-text">
										<p>Mathematical Thinking is all about processes</p>
									</div>
								</div>
								<div className="side back">
									<div className="inner-text">	
									<h5>Mathematical Thinking is all about processes</h5>
									<hr className="w-hr"/>
									<p>How to start off on a problem, what questions to ask, what strategies to consider and reflecting on your learning</p>
									</div>
								</div>
							</div>
						</div>
		 			</div> 
		 			<div data-hover-ga="Our Learnings - Multiple representations of concepts drives the learning deeper - flip" className="col-md-8 col-sm-6 flip-main">  
		 				<div className="card-container verticle-card">
							<div className="card">
								<div className="side">
									<div className="side-img">
										<img src="../img/flp6.jpg" className="flp6" alt="flip img missing"/>
										<img src="../img/flp6-new.jpg" className="flp6-new" alt="flip img missing"/>
									</div>
									<div className="bottom-text">
										<p>Multiple representations of concepts drive the learning deeper</p>
									</div>
								</div>
								<div className="side back">
									<div className="inner-text">	
									<h5>Multiple representations of concepts drive the learning deeper</h5>
									<hr className="w-hr"/>
									<p>Making connections between arithmetic, algebra and geometry develops critical thinking</p>
									</div>
								</div>
							</div>
						</div>
		 			</div> 
		 			<div data-hover-ga="Our Learnings - Attitude and Dispositions matter when it comes to Math - flip" className="col-md-4 col-sm-6 flip-main">  
		 				<div className="card-container">
							<div className="card">
								<div className="side">
									<img src="../img/flp7.jpg" alt="flip img missing"/>
									<div className="bottom-text">
										<p>Attitudes and Dispositions matter when it comes to Math</p>
									</div>
								</div>
								<div className="side back">
									<div className="inner-text">	
									<h5>Attitudes and Dispositions matter when it comes to Math</h5>
									<hr className="w-hr"/>
									<p>It is about developing good work habits, be willing to persevere and take responsibility for your learning</p>
									</div>
								</div>
							</div>
						</div>
		 			</div>  
		 			 
		 		</div>
		 	</div> 
		 </section> 
  	);
  }
}

export default FlipSection;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/FlipSection.js